import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'app/design-system/components/Button';
import { useTranslation } from 'app/lang';
import { ROUTE_PATH } from 'app/lib/routing/constants';

import EmptyStateImage from './images/empty-state.png';

import dictionary from './EmptyState.dictionary.json';

import styles from './EmptyState.module.scss';

const IMG_SIZES = {
  width: 104,
  height: 104,
};

export const EmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <img src={EmptyStateImage}
           width={IMG_SIZES.width}
           height={IMG_SIZES.height}
           alt={t(dictionary.title)} />

      <div className={styles.control}>
        <h3 className={styles.title}>
          {t(dictionary.title)}
        </h3>

        <Button data-ga-event="notification_popular_matches"
                to={ROUTE_PATH.ROOT}
                component={Link}>
          {t(dictionary.button)}
        </Button>
      </div>
    </div>
  );
};
